module.exports = __webpack_public_path__ + "static/img/rect-bg.78b7fde1.png";